/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import useHorizontalDrag from '@spotahome/ui-library/src/hooks/useHorizontalDrag';

import LazyPhoto from './LazyPhoto';

import './FullScreenPhotoListNavigator.scss';

const FullScreenPhotoListNavigator = ({
  sections,
  scrollToSection,
  activeSection
}) => {
  const {
    containerRef,
    isDragging,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd,
    navigateToItem
  } = useHorizontalDrag({
    onMoveStart: () => {},
    onMove: () => {}
  });

  useEffect(() => {
    if (activeSection) {
      navigateToItem(activeSection);
    }
  }, [activeSection]);

  const handleImageClick = caption => {
    if (isDragging()) {
      return;
    }

    scrollToSection(caption);
  };

  return (
    <ul
      className="full-screen-photo-list-navigator"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      ref={containerRef}
    >
      {sections.map(({ caption, photos: sectionPhotos }) => (
        <li key={caption} className="full-screen-photo-list-navigator__item">
          <LazyPhoto
            src={sectionPhotos[0].squareSrc}
            caption={caption}
            onImageClick={() => handleImageClick(caption)}
            className="full-screen-photo-list-navigator__image"
            imageClassName="full-screen-photo-list-navigator__image-image"
          />
          <span className="full-screen-photo-list-navigator__caption">
            {caption}
          </span>
        </li>
      ))}
    </ul>
  );
};

FullScreenPhotoListNavigator.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      caption: PropTypes.string.isRequired,
      photos: PropTypes.arrayOf(
        PropTypes.shape({
          squareSrc: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  scrollToSection: PropTypes.func.isRequired,
  activeSection: PropTypes.string.isRequired
};

export default FullScreenPhotoListNavigator;
